import { Redirect, Route, useParams } from "react-router-dom";
import Cookie from "js-cookie";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import commonData from "../importanValue";
import axios from "axios";
import Loader from "./Loader";
import { useWebsite } from "../context/WebsiteContext";

const ProtectedRoute = (props) => {
  const token = Cookie.get("jwt_token");
  const location = useLocation();
  const uid = localStorage.getItem("num");
  const { websiteId: contextWebsiteId } = useWebsite();
  const params = useParams();
  // Use websiteId from params (URL) as primary source, fallback to context
  const websiteId = params.websiteId || contextWebsiteId;

  const [loading, setLoading] = useState(true); // To handle asynchronous operations
  const [showSelection, setShowSelection] = useState(false);
  const [profileIncomplete, setProfileIncomplete] = useState(false);

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        setLoading(true);

        const headers = {
          "Content-Type": "application/json",
          authorization: token,
          "Access-Control-Allow-Origin": "*",
        };

        const userDetails = await axios.post(
          `${commonData["api"]}/get-user-details/${uid}`,
          { websiteId }, // Adding websiteId to payload
          { headers } 
        );

        if (userDetails) {
          const userInfo = userDetails.data.result[0];
          const subStr = userInfo.subjects_selected;
          const enable_english_medium = userInfo.enable_english_medium;

          // Save relevant info in localStorage
          localStorage.setItem("enable_english_medium", enable_english_medium);
          localStorage.setItem("user", userInfo.su);

          // Set state based on user details
          setShowSelection(subStr === "");
          if (
            !userInfo.first_name ||
            !userInfo.last_name ||
            !userInfo.district
          ) {
            window.location.href = `/${websiteId}/user-profile?incomplete=true`;
          }
        }
      } catch (error) {
        console.error("Error fetching user details:", error.message);
      } finally {
        setLoading(false); // Ensure loading ends
      }
    };

    if (
      token !== undefined &&
      !location.pathname.includes("select-the-exams") &&
      !location.pathname.includes("/user-profile")
    ) {
      fetchUserDetails();
    } else {
      setLoading(false);
    }
  }, [uid, JSON.stringify(location), websiteId]);

  // Redirect logic
  if (token === undefined || token === "undefined") {
    if (
      String(location.search).includes("?refer=") &&
      localStorage.getItem("refer") === undefined
    ) {
      localStorage.setItem("refer", location.search.split("?refer=")[1]);
    }
    // Ensure websiteId is in the next parameter
    const nextPath = location.pathname.startsWith(`/${websiteId}/`) || location.pathname === `/${websiteId}`
      ? location.pathname 
      : `/${websiteId}${location.pathname === '/' ? '' : location.pathname}`;
    return <Redirect to={`/${websiteId}/login/?next=${nextPath}`} />;
  } else if (loading) {
    return (
      <div className="loader-main-container">
        <Loader />
      </div>
    );
  } else if (profileIncomplete) {
    return <Redirect to={`/${websiteId}/user-profile?incomplete=true`} />;
  } 
  // else if (showSelection) {
  //   return <Redirect to={`/${websiteId}/select-the-exams?next=${location.pathname}`} />;
  // } 
  else {
    return <Route {...props} />;
  }
};

export default ProtectedRoute;
